import React from "react";
import { motion } from "framer-motion";

import {
    FaCheckCircle,
    FaTimesCircle,
    FaClock,
    FaUserCheck,
    FaPercentage,
    FaClipboardList
} from "react-icons/fa";

import "../styles/attendance-statistics.css";

export default function AttendanceStatistics({ statistics = {} }) {

    const {

        total = 0,

        present = 0,

        absent = 0,

        late = 0,

        excused = 0,

        attendance_rate = 0

    } = statistics;

    const cards = [

        {
            title: "Total Sessions",
            value: total,
            icon: <FaClipboardList />,
            color: "#6366F1",
            background: "#EEF2FF"
        },

        {
            title: "Present",
            value: present,
            icon: <FaCheckCircle />,
            color: "#16A34A",
            background: "#DCFCE7"
        },

        {
            title: "Absent",
            value: absent,
            icon: <FaTimesCircle />,
            color: "#DC2626",
            background: "#FEE2E2"
        },

        {
            title: "Late",
            value: late,
            icon: <FaClock />,
            color: "#2563EB",
            background: "#DBEAFE"
        },

        {
            title: "Excused",
            value: excused,
            icon: <FaUserCheck />,
            color: "#9333EA",
            background: "#F3E8FF"
        },

        {
            title: "Attendance Rate",
            value: attendance_rate + "%",
            icon: <FaPercentage />,
            color: "#F59E0B",
            background: "#FEF3C7"
        }

    ];

    return (

        <div className="attendance-statistics">

            {

                cards.map((card, index) => (

                    <motion.div

                        key={index}

                        className="attendance-stat-card"

                        initial={{
                            opacity: 0,
                            y: 30
                        }}

                        animate={{
                            opacity: 1,
                            y: 0
                        }}

                        transition={{
                            duration: .35,
                            delay: index * .08
                        }}

                        whileHover={{
                            y: -8,
                            scale: 1.02
                        }}

                    >

                        <div

                            className="attendance-card-icon"

                            style={{
                                color: card.color,
                                background: card.background
                            }}

                        >

                            {card.icon}

                        </div>

                        <div className="attendance-card-content">

                            <h2>

                                {card.value}

                            </h2>

                            <p>

                                {card.title}

                            </p>

                        </div>

                    </motion.div>

                ))

            }

        </div>

    );

}